export default "__VITE_ASSET__DXhctzFx__"